module.exports = __webpack_public_path__ + "images/Wassim_Alsindi.jpg?v=dab15d3cb32410229afd89bc1cb15b65";